var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.5a1 1 0 010 1.414l-4.293 4.293a1 1 0 01-1.348.061l-2.231-1.86a1 1 0 011.28-1.536l1.53 1.275L11.585 6.5A1 1 0 0113 6.5z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iNCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45OTk2IDYuNTAwMDhDMTMuMzkwMSA2Ljg5MDYgMTMuMzkwMSA3LjUyMzc2IDEyLjk5OTYgNy45MTQyOUw4LjcwNjY3IDEyLjIwNzJDOC4zNDA5NSAxMi41NzI5IDcuNzU2NyAxMi41OTk0IDcuMzU5MzggMTIuMjY4M0w1LjEyNzYgMTAuNDA4NUM0LjcwMzMyIDEwLjA1NDkgNC42NDYgOS40MjQzNSA0Ljk5OTU2IDkuMDAwMDhDNS4zNTMxMiA4LjU3NTggNS45ODM2OSA4LjUxODQ3IDYuNDA3OTYgOC44NzIwNEw3LjkzODE5IDEwLjE0NzJMMTEuNTg1MyA2LjUwMDA4QzExLjk3NTkgNi4xMDk1NSAxMi42MDkgNi4xMDk1NSAxMi45OTk2IDYuNTAwMDhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgFillCheck as ReactComponent };